// extracted by mini-css-extract-plugin
export default {"gameContentContainer":"GameContent_gameContentContainer__Ea+jc","loading":"GameContent_loading__PY+N4","error":"GameContent_error__x+gKl"};